<template>
  <v-btn-toggle v-bind="$attrs" v-model="btnValue" mandatory class="toggle base-toggle">
    <v-btn :value="leftToggle.value" :disabled="leftToggle.disabled">
      {{ leftToggle.translation }}
    </v-btn>
    <v-btn :value="rightToggle.value" :disabled="rightToggle.disabled">
      {{ rightToggle.translation }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'BaseToggle',
  props: {
    value: {
      required: false,
      type: String,
      default: '',
    },
    leftToggle: {
      required: true,
      type: Object,
    },
    rightToggle: {
      required: true,
      type: Object,
    },
  },
  emits: ['input'],
  computed: {
    btnValue: {
      get() {
        return this.value;
      },
      set(btnValue) {
        this.$emit('input', btnValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.base-toggle {
  :deep(.v-btn) {
    min-width: 70px;
    border-color: $assortment-primary-colour !important;
  }
}
</style>
